import type { FC } from 'react';
import React, { useMemo } from 'react';
import cn from 'classnames';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { NamedContainer } from '@alfa-bank/site-named-container';

import type { TInternetBank } from './models';

export const InternetBank: FC<TInternetBank> = props => {
    const {
        BannerLink,
        DataLayer,
        IconPointerDown,
        Tooltip,
        analytics,
        internetBank: { items, link, title },
        styles,
    } = props;

    const isItemsExists = Array.isArray(items) && items.length > 0;

    const buttonRender = useMemo(
        () => (
            <div className={styles.internetBankWrapper}>
                <Button
                    dataTestId="internet-bank-button"
                    href={isItemsExists ? undefined : link}
                    size="xxs"
                    type="button"
                    view="primary"
                >
                    {title}
                    {isItemsExists && (
                        <NamedContainer name="rightAddons">
                            <IconPointerDown
                                className={cn(styles.internetBankIcon, styles.external)}
                                height="6"
                                width="10"
                            />
                        </NamedContainer>
                    )}
                </Button>
            </div>
        ),
        [
            IconPointerDown,
            styles.external,
            styles.internetBankIcon,
            title,
            styles.internetBankWrapper,
            isItemsExists,
            link,
        ]
    );

    if (isItemsExists) {
        const tooltipContent = items.map(
            ({ analytics: bannerAnalytics, link: bannerLink, title: bannerTitle }, rowIndex) => {
                return (
                    <DataLayer
                        // eslint-disable-next-line react/no-array-index-key
                        key={rowIndex}
                        data={bannerAnalytics}
                    >
                        <BannerLink link={bannerLink} title={bannerTitle}>
                            <div className={styles.dropDownText}>{bannerTitle}</div>
                        </BannerLink>
                    </DataLayer>
                );
            }
        );

        return (
            <Tooltip
                className={cn(styles.internetBankTooltip, styles.external)}
                content={tooltipContent}
                contentContainerProps={{ showCloseButton: false }}
                onOpen={() => {
                    if (analytics) {
                        sendEvent(analytics);
                    }
                }}
            >
                {buttonRender}
            </Tooltip>
        );
    } else {
        return (
            <DataLayer data={analytics} tag={null}>
                {buttonRender}
            </DataLayer>
        );
    }
};
